import { Component } from '@angular/core';
import { environment } from '../../../../../../environments/environment';

@Component({
  selector: 'app-manage-queue',
  templateUrl: './manage-queue.component.html',
  styleUrl: './manage-queue.component.scss',
  standalone: false,
})
export class LossPreventionAdminManageQueueComponent {
  public readonly manageQueuesUrl = `${environment.lpBaseUrl}/reviews/queue/manage`;
}
